"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.internalExtraColors = exports.coreColors = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var primary = {
  lighter: '#f0f9f4',
  light: '#e9f7ee',
  main: '#47b972',
  dark: '#39945b',
  darker: '#2b6f44'
};
var secondary = {
  lighter: '#767676',
  light: '#474747',
  main: '#2f2f2f',
  dark: '#181818',

  /** @deprecated */
  darker: '#1b1d24'
};
var tertiary = {
  light: '#f4f4f4',
  main: '#efefef',
  dark: '#e4e4e4',
  darker: '#adadad'
};
var accent = {
  lighter: '#eef5ff',
  light: '#e5f0fe',
  main: '#2981F8',
  dark: '#2167c6',
  darker: '#194d95'
};
var danger = {
  lighter: '#fdf1f0',
  light: '#fceae9',
  main: '#e44e48',
  dark: '#b63e3a',
  darker: '#892f2b'
};
var warning = {
  lighter: '#fffaf2',
  light: '#fef7ec',
  main: '#fbbf5e',
  dark: '#c9994b',
  darker: '#977338'
};
var premium = {
  lighter: '#fcf9ef',
  light: '#faf5e7',
  main: '#d4af37',
  dark: '#aa8c2c',
  darker: '#7f6921'
};
var opacity = {
  hover: "".concat(secondary.lighter, "14"),
  active: "".concat(secondary.lighter, "29"),
  overlay: "".concat(secondary.main, "52")
};
var basic = {
  white: '#ffffff'
};
var deprecatedColors = {
  /** @deprecated */
  third: {
    lighter: '#f4f4f4',
    light: '#efefef',
    main: '#ededed',
    dark: '#e4e4e4',
    darker: '#adadad'
  },

  /** @deprecated */
  black: '#000000',

  /** @deprecated */
  white: '#ffffff'
};
var deprecatedAliases = {
  /** @deprecated */
  bodyBg: {
    main: tertiary.light
  },

  /** @deprecated */
  text: {
    light: secondary.lighter,
    main: secondary.dark
  },

  /** @deprecated */
  border: {
    light: tertiary.dark,
    main: tertiary.darker
  }
};
/** @deprecated */

var coreColors = {
  warning: {
    lighter: warning.light
  }
};
exports.coreColors = coreColors;
var internalExtraColors = {
  amber: {
    ten: '#fef2df',
    twenty: '#fde5bf',
    thirty: '#fdd99e'
  },
  grey: {
    sixty: '#5e5e5e'
  },
  green: {
    ten: '#daf1e3',
    twenty: '#b5e3c7',
    thirty: '#91d5aa'
  },
  red: {
    ten: '#fadcda',
    twenty: '#f4b8b6',
    thirty: '#ef9591'
  }
};
exports.internalExtraColors = internalExtraColors;

var _default = _objectSpread(_objectSpread({
  basic: basic,
  primary: primary,
  secondary: secondary,
  tertiary: tertiary,
  accent: accent,
  danger: danger,
  warning: warning,
  premium: premium,
  opacity: opacity
}, deprecatedColors), deprecatedAliases);

exports["default"] = _default;